import { render, staticRenderFns } from "./PhysicianViewPhysicianCompaniesCard.vue?vue&type=template&id=412b908a&"
import script from "./PhysicianViewPhysicianCompaniesCard.vue?vue&type=script&lang=js&"
export * from "./PhysicianViewPhysicianCompaniesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports